// Portfolio embed: demo auth, no real backend — default logged in as admin
import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { setAuthToken } from "../lib/api.js";
import { BOOKING_BASE } from "../constants.js";

const AuthContext = createContext(null);

const STORAGE_KEY = "portfolio_booking_user";

export const DEMO_USER = {
  id: 1,
  username: "Demo",
  email: "demo@example.com",
  role: "admin",
};

function readStoredUser() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return DEMO_USER;
    if (raw === "null" || raw === "") return null;
    return JSON.parse(raw);
  } catch {
    return DEMO_USER;
  }
}

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(readStoredUser);
  const [loading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) setAuthToken(token);
  }, []);

  const persist = (next) => {
    if (next) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      setAuthToken("demo-token");
    } else {
      localStorage.setItem(STORAGE_KEY, "null");
      setAuthToken(null);
    }
    setUser(next);
  };

  const login = async (username, password) => {
    if (!String(username || "").trim()) {
      toast.error("Username required");
      return { success: false, error: "Username required" };
    }
    if (!password) {
      toast.error("Password required");
      return { success: false, error: "Password required" };
    }
    const next = {
      ...DEMO_USER,
      username: String(username).trim(),
    };
    persist(next);
    toast.success("Signed in (demo)");
    navigate(BOOKING_BASE, { replace: true });
    return { success: true };
  };

  const signup = async (arg1, arg2, arg3) => {
    const body =
      typeof arg1 === "object" && arg1 !== null
        ? arg1
        : { username: arg1, email: arg2, password: arg3 };
    if (!body?.username?.trim()) {
      toast.error("Username required");
      return { success: false, error: "Username required" };
    }
    toast.success("Account created (demo). Signed in.");
    persist({
      id: DEMO_USER.id,
      username: body.username.trim(),
      email: (body.email || "").trim() || DEMO_USER.email,
      role: "user",
    });
    navigate(BOOKING_BASE, { replace: true });
    return { success: true, autoLogin: true };
  };

  const logout = () => {
    persist(null);
    toast.success("Signed out");
    navigate(`${BOOKING_BASE}/login`, { replace: true });
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
